import { useState } from "react";
import { ChevronDown } from "lucide-react";

const SECTIONS = [
  { id: "tms-sec-outcomes", label: "Learning Outcomes" },
  { id: "tms-sec-body", label: "The Lesson" },
  { id: "tms-sec-terms", label: "Key Terms" },
  { id: "tms-sec-sources", label: "Cited Evidence" },
  { id: "tms-sec-reflection", label: "Reflection" },
];

function scrollTo(id) {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
}

function useAvailableSections(lesson) {
  return SECTIONS.filter((s) => {
    if (s.id === "tms-sec-terms") return lesson.key_terms?.length > 0;
    if (s.id === "tms-sec-sources") return lesson.sources?.length > 0;
    if (s.id === "tms-sec-reflection") return lesson.reflection_prompts?.length > 0;
    return true;
  });
}

export function TMSLessonSectionsDesktop({ lesson }) {
  const available = useAvailableSections(lesson);
  return (
    <div data-testid="tms-lesson-sections-desktop" className="hidden xl:block sticky top-32 self-start w-full pl-8 border-l border-border/40">
      <p className="font-subtitle text-xs uppercase tracking-[0.2em] text-primary mb-6">In This Lesson</p>
      {available.map((s) => (
        <button key={s.id} data-testid={`tms-section-link-${s.id}`} onClick={() => scrollTo(s.id)}
          className="font-meta text-xs text-textSecondary hover:text-foreground mb-4 block transition-colors leading-relaxed text-left">
          {s.label}
        </button>
      ))}
    </div>
  );
}

export function TMSLessonSectionsMobile({ lesson }) {
  const [open, setOpen] = useState(false);
  const available = useAvailableSections(lesson);
  return (
    <div data-testid="tms-lesson-sections-mobile" className="xl:hidden w-full bg-card border border-border/50 p-5 my-8">
      <button data-testid="tms-lesson-sections-toggle" onClick={() => setOpen(!open)} className="w-full flex justify-between items-center font-subtitle text-sm uppercase tracking-wider text-primary">
        In This Lesson <ChevronDown className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="mt-4 flex flex-col gap-3">
          {available.map((s) => (
            <button key={s.id} data-testid={`tms-section-link-mobile-${s.id}`} onClick={() => { scrollTo(s.id); setOpen(false); }} className="text-left font-meta text-xs text-textSecondary hover:text-foreground">
              {s.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
